export default {
  flatData: (state) => {
    return state.pages.reduce((accumulator, page) => {
      return accumulator.concat(page.data)
    }, [])
  }
}
